<template>
    <modal ref="modal" :modal-backdrop="true">
        <template #body>
            <div class="text-center">
                <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-2xl" />
                <div class="mt-4 mb-4" v-html="message"></div>
                <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="close">Cancelar</button>
                <button type="button" class="px-6 py-2.5 bg-red-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1" @click.prevent="confirm">Confirmar</button>
            </div>
        </template>
    </modal>
</template>
<script>
import { ref } from 'vue';
import Modal from '@/Shared/Modal/Modal'

export default {
    components: {
        Modal,
    },
    setup(props, context) {
        const message = ref(props.message);
        const url = ref(props.url);
        const item = ref(props.item);

        const modal = ref(null);
        
        const openModalDelete = (i, u, m) => {
            url.value = u;
            item.value = i;
            message.value = m;
            modal.value.showModal = true;
        }

        const closeModalDelete = () => {
            modal.value.showModal = false;
        }

        return {
            openModalDelete,
            closeModalDelete,
            modal,
            item,
            url,
            message
        }
    },
    methods: {
        confirm() {
            this.$inertia.delete(`${this.url}`, {
                onFinish: () => {
                    this.$emit('confirm', this.item);
                    this.close();
                }
            });
        },
        open() {
            this.$refs.modal.showModal = true;
        },
        close() {
            this.$refs.modal.showModal = false;
        }
    },
}
</script>
<style>
    
</style>